import React, {useState} from "react";
import PageHeader from "../../components/PageHeader";
import DataTable from 'react-data-table-component'
import AddCompanyModal from './Add';
import ViewModal from './View';
import {Button} from "react-bootstrap";
import {customTableStyles} from "../../utils";

const EmailTemplatePage = () => {
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)


    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row) => (
                <div className="hstack gap-1 fs-1">
                    <Button aria-label="View" className="btn btn-info-light" onClick={() => {
                        setIsView(true)
                    }}>
                        <i className="ri-eye-line"/>
                    </Button>
                    <Button aria-label="Edit" className="btn btn-info-light" onClick={() => setIsEdit(true)}>
                        <i className="ri-edit-line"/>
                    </Button>
                    <Button aria-label="Delete" className="btn btn-danger-light">
                        <i className="ri-delete-bin-7-line"/>
                    </Button>
                </div>
            ),
            ignoreRowClick: true,
        },
    ];

    // Sample Data
    const data = [
        {name: "John Doe", email: "john.doe@example.com", type: "notification email"},
    ];


    return (
        <>
            <PageHeader name="Email Template"/>
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    <div className="col-auto p-0 d-flex">
                                        <Button className="btn btn-primary" onClick={() => setIsShow(true)}>
                                            Create Email Template
                                        </Button>
                                    </div>

                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary"
                                                id="basic-addon1">
                                                <i className="ri-search-line"/>
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>

                        {isShow && (
                            <AddCompanyModal
                                show={isShow}
                                handleClose={() => {
                                    setIsShow(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}
                        {/*<EditCompanyModal*/}
                        {/*    show={isEdit}*/}
                        {/*    handleClose={() => setIsEdit(false)}*/}
                        {/*/>*/}
                        <ViewModal
                            show={isView}
                            handleClose={() => setIsView(false)}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmailTemplatePage